/**
 * Chicago Futures Salon Theme - Main JavaScript
 * This file will be replaced by the built version from src/scripts/main.js
 * Run: npm run build
 */

console.log('Chicago Futures Salon theme loaded');

// Placeholder - will be replaced by Vite build
if (typeof module !== 'undefined' && module.hot) {
  module.hot.accept();
}
